"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};

var H5 = _styledComponents2.default.h5(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1rem;\n  font-weight: 700;\n  color: #4a4a4a;\n  margin: 0 0 0.5rem;\n\n  @media (min-width: 40rem) {\n    font-size: 1.125rem;\n  }\n"], ["\n  font-size: 1rem;\n  font-weight: 700;\n  color: #4a4a4a;\n  margin: 0 0 0.5rem;\n\n  @media (min-width: 40rem) {\n    font-size: 1.125rem;\n  }\n"])));
exports.default = H5;

var templateObject_1;
//# sourceMappingURL=H5.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-makeup/dist/H5/H5.js
// module id = 277
// module chunks = 0